import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  Grid,
  Tooltip,
  TableCell,
  IconButton,
} from '@material-ui/core';
import { Edit, Delete, Visibility } from '@material-ui/icons';

class TableActions extends PureComponent {
  constructor() {
    super();

    this.calculateWidth = this.calculateWidth.bind(this);
  }

  calculateWidth() {
    const { show, edit, destroy } = this.props;
    const showWidth = show ? 50 : 0;
    const editWidth = edit ? 50 : 0;
    const destroyWidth = destroy ? 50 : 0;
    return showWidth + editWidth + destroyWidth;
  }

  render() {
    const { show, edit, destroy, onShow, onEdit, onDestroy, disabled } = this.props;

    return (
      <TableCell padding="none" width={this.calculateWidth()}>
        <Grid container alignItems="center" justify="center">
          {show && <Grid item>
            <Tooltip title="Ver">
              <IconButton disabled={disabled} aria-label="Ver" onClick={onShow}>
                <Visibility />
              </IconButton>
            </Tooltip>
          </Grid>}
          {edit && <Grid item>
            <Tooltip title="Editar">
              <IconButton disabled={disabled} aria-label="Edit" onClick={onEdit}>
                <Edit />
              </IconButton>
            </Tooltip>
          </Grid>}
          {destroy && <Grid item>
            <Tooltip title="Borrar">
              <IconButton disabled={disabled} aria-label="Delete" onClick={onDestroy}>
                <Delete />
              </IconButton>
            </Tooltip>
          </Grid>}
        </Grid>
      </TableCell>
    );
  }
}

export default TableActions;

TableActions.propTypes = {
  onDestroy: PropTypes.func,
  onShow: PropTypes.func,
  onEdit: PropTypes.func,
  show: PropTypes.bool,
  destroy: PropTypes.bool,
  edit: PropTypes.bool,
  disabled: PropTypes.bool,
};

TableActions.defaultProps = {
  onDestroy: () => {},
  onShow: () => {},
  onEdit: () => {},
  show: true,
  destroy: true,
  edit: true,
  disabled: false,
};



// WEBPACK FOOTER //
// ./src/components/TableActions.js